<template>
  <v-btn
    v-if="isGroup"
    v-bind="$attrs"
    :color="active ? 'primary' : ''"
    elevation="0"
    :height="groupSize"
    :loading="loading"
    text
    tile
    :title="tooltip"
    :width="groupSize"
    x-small
    v-on="$listeners"
    :disabled="disabled"
  >
    <slot>
      <v-icon>
        {{ icon }}
      </v-icon>
    </slot>
  </v-btn>
  <div v-else class="button-container">
    <div :title="tooltip">
      <slot>
        <v-btn
          v-bind="$attrs"
          :color="active ? 'primary' : ''"
          elevation="2"
          :height="size"
          :loading="loading"
          tile
          :width="size"
          x-small
          v-on="$listeners"
          :disabled="disabled"
        >
          <slot>
            <v-icon>
              {{ icon }}
            </v-icon>
          </slot>
        </v-btn>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
    },
    tooltip: String,
    loading: Boolean,
    size: { type: Number, default: 40 },
    active: Boolean,
    disabled: Boolean,
  },
  inject: {
    isGroup: { default: false },
    groupSize: { default: 0, from: 'size' },
  },
  computed: {},
}
</script>

<style scoped>
.button-container {
  position: relative;
}
</style>
